/**
 * <ThemedIcon> — wraps a lucide icon in a theme-coloured pill.
 *
 * Use for any SVG icon that appears in light content areas (dashboards,
 * cards, stat chips, section headers). Do NOT use in the sidebar or
 * top-nav — those already follow the shell text rules.
 *
 * The icon colour + chip bg come from `--content-icon-color` and
 * `--content-icon-bg` (set by `SettingsContext.applyTheme` based on the
 * theme's `contentIconOn` field: "primary" → icon=primary, bg=secondary;
 * "secondary" → icon=secondary, bg=primary).
 */
export default function ThemedIcon({ icon: Icon, size = "md", className = "", ...rest }) {
  const iconSize = size === "sm" ? 16 : size === "lg" ? 22 : 18;
  return (
    <span className={`themed-icon-chip themed-icon-chip--${size} ${className}`.trim()} {...rest}>
      <Icon size={iconSize} strokeWidth={2} />
    </span>
  );
}
